import axiosInstance from "../axiosInstance";

/* --------------------------------------------------------------------------
 * Normalize ToEmailSourceFrom enum
 * -------------------------------------------------------------------------- */

const normalizeToEmailSourceFrom = (value) => {
  if (!value) return "";

  const normalized = String(value).trim().toLowerCase();

  const map = {
    "respective manager": "RESPECTIVE_MANAGER",
    respective_manager: "RESPECTIVE_MANAGER",

    "respective interviewer": "RESPECTIVE_INTERVIEWER",
    respective_interviewer: "RESPECTIVE_INTERVIEWER",

    branch: "BRANCH",

    "all members in project": "ALL_MEMBERS_IN_PROJECT",
    all_members_in_project: "ALL_MEMBERS_IN_PROJECT",

    "respective accountant": "RESPECTIVE_ACCOUNTANT",
    respective_accountant: "RESPECTIVE_ACCOUNTANT",

    "respective consultant": "RESPECTIVE_CONSULTANT",
    respective_consultant: "RESPECTIVE_CONSULTANT",

    "respective lead assigned employee": "RESPECTIVE_LEAD_ASSIGNED_EMPLOYEE",
    respective_lead_assigned_employee: "RESPECTIVE_LEAD_ASSIGNED_EMPLOYEE",

    "respective recruiter hr": "RESPECTIVE_RECRUITER_HR",
    respective_recruiter_hr: "RESPECTIVE_RECRUITER_HR",

    "respective project member": "RESPECTIVE_PROJECT_MEMBER",
    respective_project_member: "RESPECTIVE_PROJECT_MEMBER",

    "respective hod": "RESPECTIVE_HOD",
    respective_hod: "RESPECTIVE_HOD",

    "respective interviewers": "RESPECTIVE_INTERVIEWERS",
    respective_interviewers: "RESPECTIVE_INTERVIEWERS",

    "respective operation stage members": "RESPECTIVE_OPERATION_STAGE_MEMBERS",
    respective_operation_stage_members: "RESPECTIVE_OPERATION_STAGE_MEMBERS",

    "respective stage task assigned members":
      "RESPECTIVE_STAGE_TASK_ASSIGNED_MEMBERS",
    respective_stage_task_assigned_members:
      "RESPECTIVE_STAGE_TASK_ASSIGNED_MEMBERS",

    "respective task assigned members": "RESPECTIVE_TASK_ASSIGNED_MEMBERS",
    respective_task_assigned_members: "RESPECTIVE_TASK_ASSIGNED_MEMBERS",

    role: "ROLE",

    "respective hr": "RESPECTIVE_HR",
    respective_hr: "RESPECTIVE_HR",

    "specific employees": "SPECIFIC_EMPLOYEES",
    specific_employees: "SPECIFIC_EMPLOYEES",

    "respective employee": "RESPECTIVE_EMPLOYEE",
    respective_employee: "RESPECTIVE_EMPLOYEE",

    company: "COMPANY",

    candidate: "CANDIDATE",

    allemp: "ALLEMP",
    "all emp": "ALLEMP",
    "all employees": "ALLEMP",

    department: "DEPARTMENT",

    "respective client assigned employee":
      "RESPECTIVE_CLIENT_ASSIGNED_EMPLOYEE",
    respective_client_assigned_employee: "RESPECTIVE_CLIENT_ASSIGNED_EMPLOYEE",

    "respective vacancy creator": "RESPECTIVE_VACANCY_CREATOR",
    respective_vacancy_creator: "RESPECTIVE_VACANCY_CREATOR",

    authority: "AUTHORITY",

    "all respective next round interviewers":
      "ALL_RESPECTIVE_NEXT_ROUND_INTERVIEWERS",
    all_respective_next_round_interviewers:
      "ALL_RESPECTIVE_NEXT_ROUND_INTERVIEWERS",
  };

  return map[normalized] || value;
};

/* --------------------------------------------------------------------------
 * Normalize FromEmailSource enum
 * -------------------------------------------------------------------------- */

const normalizeFromEmailSource = (value) => {
  if (!value) return "";

  const normalized = String(value).trim().toLowerCase();

  const map = {
    "respective manager": "RESPECTIVE_MANAGER",
    respective_manager: "RESPECTIVE_MANAGER",

    "respective interviewer": "RESPECTIVE_INTERVIEWER",
    respective_interviewer: "RESPECTIVE_INTERVIEWER",

    candidate: "CANDIDATE",

    "respective accountant": "RESPECTIVE_ACCOUNTANT",
    respective_accountant: "RESPECTIVE_ACCOUNTANT",

    "respective recruiter hr": "RESPECTIVE_RECRUITER_HR",
    respective_recruiter_hr: "RESPECTIVE_RECRUITER_HR",

    "respective sales manager": "RESPECTIVE_SALES_MANAGER",
    respective_sales_manager: "RESPECTIVE_SALES_MANAGER",

    "respective hod": "RESPECTIVE_HOD",
    respective_hod: "RESPECTIVE_HOD",

    specific: "SPECIFIC",

    "respective production manager": "RESPECTIVE_PRODUCTION_MANAGER",
    respective_production_manager: "RESPECTIVE_PRODUCTION_MANAGER",

    "respective hr": "RESPECTIVE_HR",
    respective_hr: "RESPECTIVE_HR",

    tool: "TOOL",

    "respective employee": "RESPECTIVE_EMPLOYEE",
    respective_employee: "RESPECTIVE_EMPLOYEE",

    company: "COMPANY",
  };

  return map[normalized] || value;
};

/* --------------------------------------------------------------------------
 * Download Marketplace Template
 * -------------------------------------------------------------------------- */

export const downloadMarketplaceTemplate = async ({ item, type, user }) => {
  // templateCode comes from the GET response (master DB) and is passed back
  // unchanged to /save. If the record has none -> null.
  const templateCode =
    item.templateCode ||
    item.automation?.templateCode ||
    item.notification?.templateCode ||
    null;

  const employeeId =
    user?.employeeId ??
    user?.employeeID ??
    user?.empId ??
    user?.employee?.employeeId ??
    item.employeeId;

  const companyId =
    user?.companyId ??
    user?.companyID ??
    user?.tenantId ??
    user?.company?.companyId ??
    process.env.REACT_APP_COMPANY_ID ??
    item.companyId;

  /* ------------------------------------------------------------------------
   * EVENT / NOTIFICATION
   * ------------------------------------------------------------------------ */

  if (type === "event") {
    const payload = {
      scheduledEventId: item.alreadyUsed ? item.scheduledEventId || 0 : null,

      taskName: item.taskName || "",

      eventTypeId: item.eventTypeId ?? item.eventId,

      notificationTypeIds: (item.notificationTypes || []).map(
        (notificationType) => notificationType.notificationTypeId,
      ),

      toEmailSourceFrom: normalizeToEmailSourceFrom(item.toEmailSourceFrom),

      fromEmailSource: normalizeFromEmailSource(item.fromEmailSource),

      fromEmail: item.fromEmail || "",

      status: "ENABLED",

      employeeId: Number(employeeId) || 0,

      companyId: Number(companyId) || 0,

      eventTemplate: item.eventTemplate || {},

      notifyToSource: item.notifyToSource || [],

      notifyToEmails: item.notifyToEmails || [],

      templateCode,
    };

    console.log("EVENT marketplace payload:", payload);

    return axiosInstance.post(
      `${process.env.REACT_APP_API_BASE_URL}/scheduled-events/save`,
      payload,
    );
  }

  /* ------------------------------------------------------------------------
   * CRON JOB
   * ------------------------------------------------------------------------ */

  const payload = {
    scheduledCronJobId: item.alreadyUsed ? item.scheduledCronJobId || 0 : null,

    cronJobTypeId: item.cronJobTypeId ?? item.cronJobId,

    taskName: item.taskName || "",

    notificationTypeIds: (item.notificationTypes || []).map(
      (notificationType) => notificationType.notificationTypeId,
    ),

    toEmailSourceFrom: normalizeToEmailSourceFrom(item.toEmailSourceFrom),

    fromEmailSource: normalizeFromEmailSource(item.fromEmailSource),

    fromEmail: item.fromEmail || "",

    cronJobExpression: item.cronJobExpression || "* 0 8 * * *",

    triggerDate: item.triggerDate || "OnDATE",

    days: Number(item.days) || 0,

    status: "ENABLED",

    employeeId: Number(employeeId) || 0,

    companyId: Number(companyId) || 0,

    cronJobTemplate: item.cronJobTemplate || {},

    notifyToSource: item.notifyToSource || [],

    notifyToEmails: item.notifyToEmails || [],

    templateCode,

    templateStatus: "",
  };

  console.log("CRON marketplace payload:", payload);

  return axiosInstance.post(
    `${process.env.REACT_APP_API_BASE_URL}/scheduled-cron-jobs/save`,
    payload,
  );
};
